import manager from '../manager';
import {activeLazyImageDom} from '@/view/lib/lazy'

manager.add('lazyImage', function () {
	activeLazyImageDom(this.dom)
})